var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.4167C1 19.8696 1.61458 18.3859 2.70854 17.2919C3.80251 16.198 5.28624 15.5834 6.83333 15.5834H18.5C20.0471 15.5834 21.5308 16.198 22.6248 17.2919C23.7188 18.3859 24.3333 19.8696 24.3333 21.4167C24.3333 22.1903 24.026 22.9321 23.4791 23.4791C22.9321 24.0261 22.1902 24.3334 21.4167 24.3334H3.91667C3.14312 24.3334 2.40125 24.0261 1.85427 23.4791C1.30729 22.9321 1 22.1903 1 21.4167Z",
    stroke: "#BED2C2",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 9.75C15.0827 9.75 17.0415 7.79125 17.0415 5.375C17.0415 2.95875 15.0827 1 12.6665 1C10.2503 1 8.2915 2.95875 8.2915 5.375C8.2915 7.79125 10.2503 9.75 12.6665 9.75Z",
    stroke: "#BED2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.168c679275628acd3085fe3c8296d3c5.svg";
export { ForwardRef as ReactComponent };